import React from "react"
import PropTypes from "prop-types"
import LoadingSpinner from "components/LoadingSpinner"

const DesktopLimitedToTeamsSection = ({
    _TeamSelectSection,
    _WrapperComponent,
    additionalProps,
    shouldHideTeamPermissioningFormComponent,
    props,
}) => {
    if (props.loadingTeams && !shouldHideTeamPermissioningFormComponent) {
        return (
            <div style={{ height: "180px" }} >
                <LoadingSpinner id="page-loading-no-top" />
            </div>
        )
    }
    if (_WrapperComponent) {
        return (
            <_WrapperComponent {...additionalProps} {...props}>
                <_TeamSelectSection
                    clearable
                    multi
                    {...additionalProps}
                    {...props}
                />
            </_WrapperComponent>
        )
    }
    return (
        <_TeamSelectSection
            clearable
            multi
            {...additionalProps}
            {...props}
        />
    )
}

DesktopLimitedToTeamsSection.propTypes = {
    shouldHideTeamPermissioningFormComponent: PropTypes.bool,
}

DesktopLimitedToTeamsSection.defaultProps = {
    shouldHideTeamPermissioningFormComponent: false,
}

export default DesktopLimitedToTeamsSection
